// @flow

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import config from 'config'
import { LocaleContext } from '../../contexts/locale'
import germanMessages from './locales/de.yml'
import frenchMessages from './locales/fr.yml'
import { MunicipalitySearch } from '@ta-interaktiv/react-municipality-search'

const MESSAGES = {
  de: germanMessages,
  fr: frenchMessages
}

/**
 * Municipality Selection content fragment.
 * @param municipalitySelectionHandler
 * @param [locale=de]
 * @returns {*}
 * @constructor
 */
export function MunicipalitySelection({
  onMunicipalitySelection,
  locale = 'de'
}: {
  onMunicipalitySelection: number => void,
  locale: string
}) {
  const t = config.translationServiceFactory(MESSAGES, locale)

  return (
    <div className='step municipality-selection'>
      <h3 className='ui header'>{t('subtitle')}</h3>

      <MunicipalitySearch
        locale={locale}
        dedupe={true}
        onSelectionHandler={onMunicipalitySelection}
      />
    </div>
  )
}

const MunicipalitySelectionWithContext = props => (
  <LocaleContext.Consumer>
    {locale => <MunicipalitySelection locale={locale} {...props} />}
  </LocaleContext.Consumer>
)

export default MunicipalitySelectionWithContext
